"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeededCryptoSigningKeyRecipe = exports.SeededCryptoUnsealingKeyRecipe = exports.SeededCryptoSymmetricKeyRecipe = exports.SeededCryptoSecretRecipe = exports.SeededCryptoPasswordRecipe = exports.SeededCryptoRecipe = exports.HashFunction = exports.ExpensiveHashFunction = exports.CheapHashFunction = exports.WordListBitLengths = exports.WordListNames = exports.DerivableObjectNames = void 0;
const to_name_map_1 = require("./to-name-map");
const exceptions_1 = require("./exceptions");
exports.DerivableObjectNames = {
    "Password": "Password",
    "Secret": "Secret",
    "SigningKey": "SigningKey",
    "SymmetricKey": "SymmetricKey",
    "UnsealingKey": "UnsealingKey"
};
exports.WordListNames = [
    "EN_512_words_5_chars_max_ed_4_20200917",
    "EN_1024_words_6_chars_max_ed_4_20200917"
];
exports.WordListBitLengths = {
    "EN_512_words_5_chars_max_ed_4_20200917": 9,
    "EN_1024_words_6_chars_max_ed_4_20200917": 10
};
exports.CheapHashFunction = (0, to_name_map_1.toNameMap)(["BLAKE2b"]);
exports.ExpensiveHashFunction = (0, to_name_map_1.toNameMap)(["Argon2id"]);
exports.HashFunction = Object.assign(Object.assign({}, exports.CheapHashFunction), exports.ExpensiveHashFunction);
;
;
const SeededCryptoRecipeFor = (typeRequiredByOperation) => (recipeAsObjectOrJson, optionsNotSpecifiedWithinThisStandard) => {
    const recipe = (typeof recipeAsObjectOrJson === "object" && recipeAsObjectOrJson != null) ?
        recipeAsObjectOrJson :
        JSON.parse(recipeAsObjectOrJson !== null && recipeAsObjectOrJson !== void 0 ? recipeAsObjectOrJson : "{}");
    if (typeRequiredByOperation && recipe.type && recipe.type !== typeRequiredByOperation) {
        throw exceptions_1.InvalidRecipeTypeFieldException.create(typeRequiredByOperation, recipe.type);
    }
    return optionsNotSpecifiedWithinThisStandard ?
        Object.assign(Object.assign(Object.assign({}, optionsNotSpecifiedWithinThisStandard), { recipe })) :
        recipe;
};
exports.SeededCryptoRecipe = SeededCryptoRecipeFor();
exports.SeededCryptoPasswordRecipe = SeededCryptoRecipeFor("Password");
exports.SeededCryptoSecretRecipe = SeededCryptoRecipeFor("Secret");
exports.SeededCryptoSymmetricKeyRecipe = SeededCryptoRecipeFor("SymmetricKey");
exports.SeededCryptoUnsealingKeyRecipe = SeededCryptoRecipeFor("UnsealingKey");
exports.SeededCryptoSigningKeyRecipe = SeededCryptoRecipeFor("SigningKey");
// const test = SeededCryptoPasswordRecipe({
//   hashFunction: "BLAKE2b",
//   lengthInBits: 3,
//   lengthInWords: 3,
//   hashFunctionMemoryPasses: undefined,
//   hashFunctionMemoryLimitInBytes: 3,
// }, {})
//# sourceMappingURL=seeded-crypto-recipe.js.map